import icon from "@material-ui/icons/Map"

export default { icon } ;